import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { EnvironmentService } from '../../environments/environment.service';
import { generateTraceparent, TRACEPARENT_HEADER } from '../utils/trace-context';
import { TracedHttpErrorResponse } from './traceparent-interceptor.models';

export function traceparentInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const environment = inject(EnvironmentService);

  if (!isTracedUrl(req.url, environment)) {
    return next(req);
  }

  const traceparent = generateTraceparent();

  return next(req.clone({ headers: req.headers.set(TRACEPARENT_HEADER, traceparent) })).pipe(
    catchError((error: unknown) =>
      throwError(() => (error instanceof HttpErrorResponse ? new TracedHttpErrorResponse(error, traceparent) : error)),
    ),
  );
}

// Add a backend here only once its CORS preflight allows the header; a backend that rejects it loses every request.
// Checked on DEV and QA: Ditto allows it, the fleet, property-status and api-gateway services do not.
function isTracedUrl(url: string, environment: EnvironmentService): boolean {
  return [environment.dittoUrl].some((tracedUrl) => url.startsWith(tracedUrl));
}
